var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadAppStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 70,
    viewBox: "0 0 65 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.516 0.13215C38.8956 0.418848 39.89 1.67776 39.9894 3.17357C40.325 7.86047 41.4561 19.8769 44.4391 24.1525C47.7329 28.8394 59.2175 34.2368 63.0085 35.932C64.4006 36.5553 65.2209 38.1384 64.8853 39.709C64.8853 39.734 64.8853 39.7464 64.8729 39.7713C64.5497 41.1924 63.3441 42.202 61.9769 42.3267C57.8752 42.6882 46.1668 43.9721 42.09 47.2504C37.5408 50.9027 32.3081 63.4801 30.7047 67.5188C30.22 68.7528 29.1138 69.6254 27.8584 69.6628C27.411 69.6752 26.9635 69.6129 26.5409 69.4757C25.3477 69.0893 24.5274 67.9177 24.4155 66.5839C24.0426 62.271 22.663 48.9456 19.3941 44.2463C16.4483 40.0081 6.20658 35.5207 2.03033 33.813C0.663108 33.252 -0.169655 31.7811 0.0292136 30.223C0.0292136 30.1482 0.0540775 30.0734 0.0540775 29.9986C0.277805 28.4779 1.47102 27.3186 2.90039 27.1316C7.3998 26.5458 18.8472 24.7633 23.011 21.4725C27.1997 18.0695 31.8607 6.62646 33.551 2.20133C34.0855 0.8177 35.3782 -0.0922687 36.7702 0.00745252C37.0312 0.0323828 37.2923 0.0698118 37.5408 0.119672L37.516 0.13215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppStar);
export default __webpack_public_path__ + "static/media/Download-App-Star.ef5f104988b3eaa194fd46f430083ab6.svg";
export { ForwardRef as ReactComponent };